(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.service('insertionOrderApi', [
    '$http',
    '$q',
    function($http, $q) {
      this.getList = function(sort, search, page, advertiserId, status) {
        var url = '/demandmgr/insertion-order/list';

        url = url + '?sortField=' + sort.field;
        url = url + '&sortOrder=' + sort.order;
        url = url + '&search=' + search;
        url = url + '&pageNumber=' + page.number;
        url = url + '&pageSize=' + page.size;
        url = url + '&pageSize=' + page.size;
        if (advertiserId && advertiserId !== '*') {
          url = url + '&advertiserId=' + advertiserId;
        }

        if (status) {
            url = url + '&status=' + status;
        }

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              console.log(res);

              reject();
            }
          );
        });
      };


      this.getStatCDP = function(io_list) {
        var url = '/demandmgr/insertion-order/stats?ioIds=';
        if (io_list.length > 0) {
          url += io_list.join(',');
        }
        return $q(function(resolve, reject) {
          $http.get(url).then(
              function(res) {
                resolve(res.data);
              },
              function(res) {
                console.log(res);
                reject();
              }
          );
        });
      };

      this.getCampaignStat = function(io_list) {
        var url =
          '/reportsvwr/api?req=campaignDeliveryDaily&_f=json&useCache=1&groupBy=cid&extended=1';
        if (io_list.length > 0) {
          url += '&insertionOrderId=' + io_list.join(',');
        }
        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              console.log(res);
              reject();
            }
          );
        });
      };

        this.getCampaignStatToday = function(io_list) {
            var url =
                '/reportsvwr/api?req=campaignDeliveryDaily&_f=json&useCache=1&groupBy=cid&extended=1&today=1';
            if (io_list.length > 0) {
                url += '&insertionOrderId=' + io_list.join(',');
            }
            return $q(function(resolve, reject) {
                $http.get(url).then(
                    function(res) {
                        resolve(res.data);
                    },
                    function(res) {
                        console.log(res);
                        reject();
                    }
                );
            });
        };

      this.toggleActive = function(ioId) {
        var url = '/demandmgr/insertion-order/toggle-active?id=' + ioId;

        return $q(function(resolve, reject) {
          $http.put(url).then(
            // success
            function(res) {
              resolve();
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.delete = function(ioId) {
        var url = '/demandmgr/insertion-order?id=' + ioId;

        return $q(function(resolve, reject) {
          $http.delete(url).then(
            // success
            function(res) {
              resolve();
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.save = function(io) {
        var url = '/demandmgr/insertion-order/save';

        return $q(function(resolve, reject) {
          $http.post(url, io).then(
            // success
            function(res) {
                if (res.data.status === 'success') {
                    resolve();
                } else {
                    reject(res.data);
                }
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.read = function(ioId) {
        var url = '/demandmgr/insertion-order/read?id=' + ioId;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.isIoNameUnique = function(advertiserId, ioName, ioId) {
        var url =
          '/demandmgr/insertion-order/check-name?advertiserId=' +
          advertiserId +
          '&id=' +
          ioId +
          '&name=' +
          ioName;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function() {
              reject();
            }
          );
        });
      };

      this.getCampaigns = function(ioId) {
        var url = '/demandmgr/insertion-order/campaign?ioId=' + ioId;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function() {
              reject();
            }
          );
        });
      };
    },
  ]);
})(window.angular);
